//测试
export const baseURL = 'https://test.orotalive.com:8200'
//生产
// export const baseURL = 'https://api.sancttech.com:8200'
// export const baseURL = '/api'